// extracted by mini-css-extract-plugin
export default {"container":"login_container__0XDSK","title":"login_title__A422S","form":"login_form__BUTmZ","card":"login_card__V3Zfp","button":"login_button__gU7sR"};